import script from "./BannerOverview.vue?vue&type=script&setup=true&lang=ts"
export * from "./BannerOverview.vue?vue&type=script&setup=true&lang=ts"

import "./BannerOverview.vue?vue&type=style&index=0&id=ded73df6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ded73df6"]])

export default __exports__